import React from 'react';
import { View } from 'react-native-web';
import { NOTE_str } from '../../../utils/DictionaryManagementUtils';
import { LocStr } from '../../../utils/Utils';
import RegularText from './RegularText';

//= ========================================================================

const NoteMessage = ({
  language,
  children,
}) => (
  <View
    style={{
      padding: 20,
      backgroundColor: 'rgba(0, 216, 32, 0.1)',
      border: 'solid 1px rgba(0, 216, 32, 0.36)',
      borderRadius: 2,
      marginBottom: 10,
    }}
  >
    <RegularText isSemiBold>{LocStr(NOTE_str, language)}</RegularText>
    <RegularText marginBottom={0}>{children}</RegularText>
  </View>
);
export default NoteMessage;
